export enum DigitalSignatureAction {
  None = 1,
  Send,
  Cancel,
}
